import type { Component } from 'vue';
import { h } from 'vue';
import { ColumnHelper } from '@tanstack/vue-table';

import CodeCellRenderer from '../components/common/CodeCellRenderer.vue';
import { COST_TYPE_FILTER_OPTIONS } from '../constants/options';
import { CostTypes, WeightTypes } from '../types/common-aggregated';
import { parseYearMonth } from '../utils/options';

export const getCodeCell = <T extends { code: string | null }>(columnHelper: ColumnHelper<T>) => {
  // @ts-ignore
  return columnHelper.accessor((row) => row.code, {
    header: 'Код ТН ВЭД',
    size: 112,
    meta: {
      class: 'code-cell',
      fixed: true,
    },
    // Явно приводим компонент к типу Component, чтобы согласовать типы Vue в @tanstack/vue-table и проекте
    cell: (data) => h(CodeCellRenderer as Component, { code: data.getValue() }),
  });
};

export const getProductNameCell = <T extends { product: string }>(columnHelper: ColumnHelper<T>) => {
  // @ts-ignore
  return columnHelper.accessor('product', {
    header: 'Товар',
    size: 400,
    meta: {
      class: 'product-cell',
      fixed: true,
    },
  });
};

export const costTypeTableTextMap = COST_TYPE_FILTER_OPTIONS.reduce(
  (acc, item) => ({ ...acc, [item.value]: item.label.toLowerCase() }),
  {} as Record<CostTypes, string>,
);

export const weightTableTextMap: Record<WeightTypes, string> = {
  [WeightTypes.KILOS]: 'килограмм',
  [WeightTypes.TONS]: 'тонн',
  [WeightTypes.THOUSANDS_TONS]: 'тыс. тонн',
  [WeightTypes.MILLIONS_TONS]: 'млн. тонн',
};

export const getCumulativeMonthPeriodLabel = (yearMonth: string): string => {
  const { year, month, labelShort } = parseYearMonth(yearMonth);

  if (!year || !month) return String(yearMonth);

  return month === 1 ? `${labelShort} ${year}` : `янв - ${labelShort} ${year}`;
};
